'use client';

import { useViewport } from '@/hooks';
import { ImageProps } from 'next/image';
import { Img } from '../ui';

type MasonryItemProps = {
  idx: number;
  priorityList: {
    web: number[];
    mobile: number[];
    tablet: number[];
  };
} & ImageProps;

const MasonryItem: React.FC<MasonryItemProps> = (props: MasonryItemProps) => {
  const { idx, priorityList, ...rest } = props;
  const { isMobile, isDesktop, isTablet } = useViewport();

  let isPriority = false;

  switch (true) {
    case isMobile:
      isPriority = priorityList.mobile.includes(idx);
      break;
    case isTablet:
      isPriority = priorityList.tablet.includes(idx);
      break;
    case isDesktop:
      isPriority = priorityList.web.includes(idx);
      break;
    default:
      isPriority = false;
      break;
  }

  return (
    <Img
      placeholder="blur"
      {...rest}
      className="w-full rounded-xl"
      sizes="(max-width: 768px) 50vw, 33vw"
      priority={isPriority}
    />
  );
};

export default MasonryItem;
